import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navItems = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "services", label: "Services" },
    { id: "projects", label: "Projects" },
    { id: "service-area", label: "Service Area" },
    { id: "contact", label: "Contact" },
  ];

  return (
    <footer className="bg-[hsl(var(--navy))] text-white rebar-trace">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-11 h-11 rounded-sm font-heading text-2xl text-white leading-none bg-[#194d32]">
                NCC
              </div>
              <div className="leading-tight">
                <div className="font-heading text-lg tracking-wide">
                  NATURALS CONCRETE
                </div>
                <div className="font-heading text-sm tracking-[0.2em] text-[#194d32]">
                  CONSTRUCTION
                </div>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Professional concrete construction services for Northwest Arkansas
              and surrounding areas.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="section-label mb-4 text-[#194d32] text-base">
              Navigation
            </h3>
            <ul className="space-y-2.5">
              {navItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-white/70 hover:text-[hsl(var(--accent))] transition-colors text-sm font-medium uppercase tracking-wider focus-ring rounded"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="section-label mb-4 text-[#194d32] text-base">
              Legal
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/terms"
                  className="text-white/70 hover:text-[hsl(var(--accent))] transition-colors text-sm font-medium uppercase tracking-wider focus-ring rounded"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-white/70 hover:text-[hsl(var(--accent))] transition-colors text-sm font-medium uppercase tracking-wider focus-ring rounded"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="section-label mb-4 text-[#194d32] text-base">
              Contact
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:+14794227180"
                  className="flex items-center gap-2.5 text-white/70 hover:text-[hsl(var(--accent))] transition-colors"
                >
                  <Phone size={16} className="text-[#194d32]" />
                  479-422-7180
                </a>
              </li>
              <li>
                <a
                  href="tel:+14793650222"
                  className="flex items-center gap-2.5 text-white/70 hover:text-[hsl(var(--accent))] transition-colors"
                >
                  <Phone size={16} className="text-[#194d32]" />
                  479-365-0222
                </a>
              </li>
              <li>
                <a
                  href="mailto:naturalconcrete.contruction@gmail.com"
                  className="flex items-center gap-2.5 text-white/70 hover:text-[hsl(var(--accent))] transition-colors break-all"
                >
                  <Mail size={16} className="flex-shrink-0 text-[#194d32]" />
                  naturalconcrete.contruction@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-white/70">
                <MapPin size={16} className="flex-shrink-0 mt-0.5 text-[#194d32]" />
                Northwest Arkansas &amp; Surrounding Areas
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 text-center text-white/40 text-sm flex flex-col sm:flex-row items-center justify-center gap-4">
          <span>
            &copy; {currentYear} Naturals Concrete Construction. All Rights Reserved.
          </span>
          <span className="hidden sm:inline text-white/20">|</span>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-white transition-colors">
              Terms
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}